<div class="modal" #modal>
	<div class="modal__after"></div>
	<div class="modal__wrapper">
		<ng-content></ng-content>
	</div>
</div>
